module.exports = __webpack_public_path__ + "img/green-checkmark.dd8c3239.svg";